import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { SidebarAccount } from "~/components/layout/sidebar/SidebarAccount";
import { SidebarBenchmark } from "~/components/layout/sidebar/SidebarBenchmark";
import { SidebarBottom } from "~/components/layout/sidebar/SidebarBottom";
import { SidebarCompany } from "~/components/layout/sidebar/SidebarCompany";
import { SidebarCompensationReviews } from "~/components/layout/sidebar/SidebarCompensationReviews";
import { SidebarLogo } from "~/components/layout/sidebar/SidebarLogo";
import { SidebarYourData } from "~/components/layout/sidebar/SidebarYourData";
import { Sidebar, SidebarContent, SidebarRail, useSidebar } from "~/components/ui/shadcn/ui/sidebar";
import { useSession } from "~/hooks/useSession";

export const AppSidebar: React.FC<React.ComponentProps<typeof Sidebar>> = (props) => {
  useSidebarToggleOnScreenResize();

  return (
    <Sidebar collapsible="icon" {...props}>
      <SidebarLogo />

      <SidebarContent>
        <SidebarYourData />
        <SidebarBenchmark />
        <SidebarCompensationReviews />
        <SidebarBottom />
      </SidebarContent>

      <SidebarCompany />
      <SidebarAccount />

      <SidebarRail />
    </Sidebar>
  );
};

const useSidebarToggleOnScreenResize = () => {
  const theme = useTheme();
  const isSmallDesktop = useMediaQuery(theme.breakpoints.down("lg"));
  const { user } = useSession();
  const { setOpen } = useSidebar();

  useEffect(() => {
    if (isSmallDesktop) {
      setOpen(false);
    } else if (!user || user?.flags.expandSidebar) {
      setOpen(true);
    }
  }, [isSmallDesktop, user]);
};
